import _ from "lodash";
import { BFO_INSTRUMENTS } from "v2/common/constants";
import { LocaleUtils } from "v2/common/utils/zeequantConstants";

const CRYPTOBOT = 'cryptobot'
const COINDCX = 'coin_dcx'

export const formatInstrumentPrefix = (instrument: string): string => {
  if (LocaleUtils().isCrypto()) return instrument;

  return `${_.includes(BFO_INSTRUMENTS, instrument) ? 'BFO' : 'NFO'}:${instrument}`;

}

const getCryptoInstruments = (instruments: string[]) => {
  return instruments.filter((instrument) => instrument.includes('DEX:'))
}

const getCoinDCXInstruments = (instruments: string[]) => {
  return instruments.filter((instrument) => instrument.includes('CDCX:'))
}

export const getInstrumentsLocaleWise = (name: string, instruments: string[], isIndiaVersion: boolean) => {
  if (isIndiaVersion) return instruments;
  if (name === COINDCX) return getCoinDCXInstruments(instruments);
  return getCryptoInstruments(instruments);
}
